import React from 'react'
import { Link } from 'react-router-dom';
import styled from 'styled-components'
import { mobile } from '../responsive';

const Container = styled.div`
    ${mobile({ paddingTop: "25px", height: "10px" })}
`;

const Text = styled.div`
    height: 150%;
    background-color: #0039a6;
    color: white;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 10px;
    ${mobile({ marginTop: "-15px", height: "100%", padding: "8px" })};
`


const AllDataLine = () => {
  return (
    <Container>
      <Text>
        For a list without categories  &nbsp;<Link to='/catalog/all' style={{color: 'white', fontWeight: '500'}}>click here</Link>
      </Text>
    </Container>
  )
}

export default AllDataLine